export default {"src":"/_next/static/media/nielsen_black.1737efec.svg","height":48,"width":211,"blurWidth":0,"blurHeight":0};